import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical, TextP } from '../../../index';
import { DsiCheckBox as CheckBox } from '../General/Checkbox';
import { ProductFilterItem } from './ProductFilterItem';
import { __ } from 'react-i18n';
import { Loader } from '../../Defaults/Loader';

interface Props {
  isMobile: boolean | false;
  handleFilterChange: any;
  showVat?: boolean;
  showVocMoc?: boolean;
  handleCheckboxChange?: any;
  priceInitial: any;
  priceCurrent: any;
  currency: string;
  data: any;
  vocMoc?: string;
  vatView?: string;
  hasOnStockFilter?: boolean;
  hasOnlyWithParentFitler?: boolean;
  aggData: any;
  ignoreFilters?: string[];
  isFetching?: boolean;
}

function ProductFilter({
  isMobile,
  handleFilterChange,
  handleCheckboxChange,
  priceInitial,
  priceCurrent,
  currency,
  data,
  showVat,
  showVocMoc,
  vocMoc,
  vatView,
  hasOnStockFilter,
  hasOnlyWithParentFitler,
  aggData,
  ignoreFilters,
  isFetching
}: Props) {

  return (
    <Loader loading={isFetching?true:false}>
      <FilterItem isMobile={isMobile}>
        <ProductFilterItem
          isDropdownOpen={true}
          name={__('Cena')}
          type={'price'}
          handleFilterChange={handleFilterChange}
          priceInitial={priceInitial}
          priceCurrent={priceCurrent}
          currency={currency}
          data={data}
          hasOnStockFilter={hasOnStockFilter}
          hasOnlyWithParentFitler={hasOnlyWithParentFitler}
          aggData={aggData}
          ignoreFilters={ignoreFilters}
        />
      </FilterItem>
      {/* <CheckBoxWrapper>
        <CheckBox name="moc" selected={false} rounded={true} />
        <StyledLabel htmlFor="moc" selected={false}>
          {'MOC'}
        </StyledLabel>
      </CheckBoxWrapper> */}
      {!!showVat && (
        <FilterCheckBoxItem isMobile={isMobile}>
          <CheckBoxWrapper>
            <CheckBox
              // tslint:disable-next-line:jsx-no-lambda
              onClick={e => handleCheckboxChange('vat', 'withVat')}
              name="withVat"
              selected={vatView === 'withVat'}
              rounded={true}
            />
            <StyledLabel
              // tslint:disable-next-line:jsx-no-lambda
              onClick={e => handleCheckboxChange('vat', 'withVat')}
              htmlFor="withVat"
              selected={vatView === 'withVat'}
            >
              {__('s DPH')}
            </StyledLabel>
          </CheckBoxWrapper>
          <CheckBoxWrapper>
            <CheckBox
              // tslint:disable-next-line:jsx-no-lambda
              onClick={e => handleCheckboxChange('vat', 'withoutVat')}
              name="withoutVat"
              selected={vatView === 'withoutVat'}
              rounded={true}
            />
            <StyledLabel
              // tslint:disable-next-line:jsx-no-lambda
              onClick={e => handleCheckboxChange('vat', 'withoutVat')}
              htmlFor="withoutVat"
              selected={vatView === 'withoutVat'}
            >
              {__('bez DPH')}
            </StyledLabel>
          </CheckBoxWrapper>
        </FilterCheckBoxItem>
      )}
      {!!showVocMoc && (
        <FilterCheckBoxItem isMobile={isMobile}>
          <CheckBoxWrapper>
            <CheckBox
              // tslint:disable-next-line:jsx-no-lambda
              onClick={e => handleCheckboxChange('vocmoc', 'voc')}
              name="voc"
              selected={vocMoc === 'voc'}
              rounded={true}
            />
            <StyledLabel
              // tslint:disable-next-line:jsx-no-lambda
              onClick={e => handleCheckboxChange('vocmoc', 'voc')}
              htmlFor="voc"
              selected={vocMoc === 'voc'}
            >
              {__('VOC')}
            </StyledLabel>
          </CheckBoxWrapper>
          <CheckBoxWrapper>
            <CheckBox
              // tslint:disable-next-line:jsx-no-lambda
              onClick={e => handleCheckboxChange('vocmoc', 'moc')}
              name="moc"
              selected={vocMoc === 'moc'}
              rounded={true}
            />
            <StyledLabel
              // tslint:disable-next-line:jsx-no-lambda
              onClick={e => handleCheckboxChange('vocmoc', 'moc')}
              htmlFor="moc"
              selected={vocMoc === 'moc'}
            >
              {__('MOC')}
            </StyledLabel>
          </CheckBoxWrapper>
        </FilterCheckBoxItem>
      )}
      {/* <FilterItem isMobile={isMobile}>
        <ProductFilterItem
          name={'Značka'}
          type={'select'}
          handleFilterChange={handleFilterChange}
        />
      </FilterItem>
      <FilterItem isMobile={isMobile}>
        <ProductFilterItem
          name={'Typ pripojenia'}
          type={'select'}
          handleFilterChange={handleFilterChange}
        />
      </FilterItem> */}
    </Loader>
  );
}

const FilterItem = styled.div<{ isMobile: boolean | false }>`
  background: ${({ theme, isMobile }) =>
    !isMobile ? theme.productFilter.backgroundColor : theme.colors.white};
  padding: ${rem(32)};
  margin-bottom: ${rem(2)};

  &:first-child {
    border-radius: 4px 4px 0 0;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }

  ${({ theme }) => theme.mediab.l925`
    padding: ${rem(24)} ${rem(16)};
    margin-bottom: 0;
    border-bottom: ${rem(1)} solid #eeeeee;
  `}
`;

export const ItemTitle = styled(TextP)`
  font-size: ${rem(20)};
  font-weight: 500;
  line-height: ${rem(24)};

  ${({ theme }) => theme.mediab.l925`
    font-size: ${rem(18)};
    line-height: ${rem(22)};
  `}
`;

export const ItemTitleWrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  cursor: pointer;
`;

export const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledLabel = styled.label<{ selected: boolean }>`
  font-size: ${rem(16)};
  font-weight: ${({ selected }) => (selected ? 500 : 400)};
  margin-right: ${rem(24)};
  cursor: pointer;
  color: ${({ selected, theme }) =>
    selected ? '#1E398D' : theme.colors.textPrimary};
`;

const FilterCheckBoxItem = styled(FilterItem)`
  display: flex;
  flex-direction: row;
`;

export const TitleIconWrapper = styled.div`
  svg {
    * {
      fill: ${({ theme }) => theme.colors.textPrimary};
    }
  }
`;

export { ProductFilter as DsiProductFilter };
